import { axiosInstanceV2 } from "../axios";

export const getPlans = (id) => {
    if (!id) return [];
    const url = `/agreement-plans/?for_agreement=${id}`;
    return axiosInstanceV2.get(url).then(({ data }) => data.results);
};
